import { render, staticRenderFns } from "./CreateGarage.vue?vue&type=template&id=3d3c82bc"
import script from "./CreateGarage.vue?vue&type=script&lang=js"
export * from "./CreateGarage.vue?vue&type=script&lang=js"
import style0 from "./CreateGarage.vue?vue&type=style&index=0&id=3d3c82bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports